import { render, staticRenderFns } from "./SectionView.vue?vue&type=template&id=6c24bca8&scoped=true"
import script from "./SectionView.vue?vue&type=script&lang=js"
export * from "./SectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24bca8",
  null
  
)

export default component.exports